import PenerimaPettyCashApi from './PenerimaPettyCashApi';

export default PenerimaPettyCashApi;
